import { Pagination } from '@mui/material';
import { useAuth } from '../context/Auth';
import { ChangeEvent, FC } from 'react';
import { useRouter } from 'next/router';
import { routes } from '../config/routes';

interface Props {
  total: number;
  itemsPerPage: number;
  offsetChange: (event: ChangeEvent, page: number) => void;
  offset: number;
  blockSecondPageIfNotAuthenticated?: boolean;
}

export const Paginator: FC<Props> = ({
  total,
  itemsPerPage,
  offsetChange,
  offset,
  blockSecondPageIfNotAuthenticated = false,
}) => {
  const { isAuthenticated } = useAuth();
  const { push } = useRouter();
  const numberOfPages = Math.ceil(total / itemsPerPage);

  if (!numberOfPages || numberOfPages <= 1) return null;

  const onChange = (event: ChangeEvent, page: number) => {
    if (blockSecondPageIfNotAuthenticated && !isAuthenticated && page > 1) {
      push(routes.SIGN_IN());
      return;
    }

    offsetChange(event, page);
  };

  return (
    <Pagination
      color="primary"
      page={offset + 1}
      onChange={onChange}
      count={numberOfPages}
    />
  );
};
